module.exports = __webpack_public_path__ + "img/Damp1.jpg";